const PageNotFound = () => {
  return (
    <figure className="flex-row align-center">
      <img
        className="img-responsive"
        width="840"
        height="420"
        src="https://cdn.discordapp.com/attachments/893545064062660641/976370998083473418/404_Error-bro.png"
        alt="404 OOPS PAGE NOT FOUND"
      />
    </figure>
  );
};

export { PageNotFound };
